module.exports = __webpack_public_path__ + "static/glasengel_1.761c6f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/glasengel_1.jpg
// module id = 556
// module chunks = 35783957827783